(() => {
  const initialise = (root = document) => {
    root.querySelectorAll('[data-aroha-quote]').forEach((card) => {
      if (card.dataset.ready) return;
      card.dataset.ready = 'true';
      const form = card.querySelector('form') || card.querySelector('[data-preview-fields]');
      const piece = card.querySelector('[data-quote-piece]');
      const placement = card.querySelector('[data-quote-placement]');
      const options = [...placement.options].map((option) => option.cloneNode(true));
      const updatePlacement = () => {
        const value = placement.value;
        placement.replaceChildren(...options.filter((option) => option.dataset.piece === piece.value).map((option) => option.cloneNode(true)));
        if ([...placement.options].some((option) => option.value === value)) placement.value = value;
        card.querySelector('[data-quote-result]').hidden = true;
      };
      piece.addEventListener('change', updatePlacement);
      updatePlacement();
      const review = card.querySelector('[data-quote-review]');
      if (review) {
        form.addEventListener('submit', (event) => event.preventDefault());
        review.addEventListener('click', () => {
          const invalid = [...form.querySelectorAll('input, select, textarea')].find((field) => !field.checkValidity());
          if (invalid) { invalid.reportValidity(); return; }
          const result = card.querySelector('[data-quote-result]');
          result.hidden = false;
          result.focus({ preventScroll: true });
          result.scrollIntoView({ block: 'nearest', behavior: 'auto' });
        });
        form.addEventListener('input', () => { card.querySelector('[data-quote-result]').hidden = true; });
      }
    });
    root.querySelectorAll('.aa-mobile-nav').forEach((menu) => {
      if (menu.dataset.ready) return;
      menu.dataset.ready = 'true';
      menu.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => { menu.open = false; }));
      menu.addEventListener('keydown', (event) => { if (event.key === 'Escape') { menu.open = false; menu.querySelector('summary').focus(); } });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialise());
  else initialise();
  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
})();
